import React, { useEffect, useState } from "react";

import { Card, Col, Row } from "react-bootstrap";
import axios from "axios";

import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ServiceUrl } from "../../utils/serviceUrl";
import { getFileLiveUrl } from "../../utils";

const OurGallery = (props) => {
  const [toggler, setToggler] = useState(false);

  const [loader, setLoader] = useState(false);
  const [sliders, setSliders] = useState([]);

  useEffect(() => {
    loadImages();
  }, []);

  const loadImages = () => {
    setLoader(true);
    axios.get(ServiceUrl.RECENT_GALLERY).then((res) => {
      if (res["data"].status == "1") {
        setSliders(res["data"].data);
        setLoader(false);
      }
    });
  };

  var settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 400,
    slidesToShow: 4,
    slidesToScroll: 2,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 0,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div data-aos="fade-up" className="py-5">
      <Slider {...settings}>
        {sliders.map((item, i) => {
          return (
            <div className="px-2">
              <Card>
                <Card.Img
                  src={getFileLiveUrl(item.feature_image)}
                  onClick={(e) => setToggler(true)}
                  height="200px"
                  width="100%"
                />
              </Card>
            </div>
          );
        })}
      </Slider>
    </div>
  );
};

export default OurGallery;
